// import {
//   Box,
//   Autocomplete,
//   TextField,
//   Button,
//   Alert,
//   Snackbar,
// } from "@mui/material";
import { TextField, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./ManageRateMaster.css";
import { Loader } from "../../components/loader/Loader";
// import { openPopup } from "../../stateManagement/actions/popupActions";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import DefaultHeading from "../../components/heading/DefaultHeading";
import {
  getRateMasterData,
  formatDate,
  approveRejectRateMaster,
} from "./RateMasterService";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
// import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { popupType } from "../../types/types";
import { GenericPopUp } from "../../components/popup/genericPopUp";
// import { getLob } from "../../services/authenticationService";
// import { downloadReport, getReport, task } from "../../services/reportService";

function ManageRateMaster() {
  const { translate } = usePortalTranslation();
  const [showLoader, setShowLoader] = useState<boolean>(false);

  const [rateMasterData, setRateMasterData] = useState<any[]>([]);
  //   const [confirmPopupState, setConfirmPopupState] = useState<boolean>(false);
  //   const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [approvalReasons, setApprovalReasons] = useState<{
    [key: string]: string;
  }>({});

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");
  //   const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);

  const designation = JSON.parse(localStorage.authContext).user.designation[0];

  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };

  const fetchRateMasterData = async () => {
    setShowLoader(true);
    const rateMasterData = await getRateMasterData();
    setRateMasterData(rateMasterData);
    setShowLoader(false);
  };

  useEffect(() => {
    fetchRateMasterData();
  }, []);

  const handleApprovalReasonChange = (id: string, value: string) => {
    setApprovalReasons((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleApproveReject = (statusToUpdate: string, row: any) => {
    const approvalReason = approvalReasons[row.id] || "";

    if (!approvalReason) {
      openPopUp("Please fill in the approval reason.", "Alert");
      return;
    }

    approveRejectRateMaster(statusToUpdate, row, approvalReason)
      .then((statusMessage) => {
        if (statusMessage === "success") {
          openPopUp(
            "Your information has been updated successfully.",
            "Success"
          );
        } else openPopUp(statusMessage, "Alert");
        setApprovalReasons({});
        fetchRateMasterData();
      })
      .catch((error) => {
        console.error("Error updating status:", error);
      });
  };

  const columns: GridColDef[] = [
    { field: "created_by", headerName: "Created By", flex: 1 },
    { field: "sheetName", headerName: "Sheet Name", flex: 1 },
    { field: "designation", headerName: "Designation", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
    {
      field: "last_modified_time",
      headerName: "Date",
      flex: 1,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      field: "creation_time",
      headerName: "Creation Time",
      flex: 1,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      field: "approval_reason",
      headerName: "Approval Reason",
      flex: 1.5,
      renderCell: (params) => (
        <TextField
          size="small"
          placeholder="Enter reason"
          value={approvalReasons[params.row.id] || ""}
          onChange={(e) =>
            handleApprovalReasonChange(params.row.id, e.target.value)
          }
        />
      ),
    },
    {
      field: "approve",
      headerName: "Approve",
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#23c6b0",
            "&:hover": { backgroundColor: "#1da898" },
          }}
          size="small"
          onClick={() => {
            if (designation === "expenseapprover1") {
              handleApproveReject("A1Approved", params.row);
            } else if (designation === "expenseapprover2") {
              handleApproveReject("Approved", params.row);
            }
          }}
        >
          Approve
        </Button>
      ),
    },
    {
      field: "reject",
      headerName: "Reject",
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleApproveReject("Reject", params.row)}
        >
          Reject
        </Button>
      ),
    },
    // {
    //   field: "download",
    //   headerName: "Download",
    //   flex: 0.8,
    //   renderCell: (params) => (
    //     <Button
    //       variant="contained"
    //       color="primary"
    //       size="small"
    //       onClick={() => {
    //         setSelectedRowData(params.row);
    //         setConfirmPopupState(true);
    //       }}
    //     >
    //       Download
    //     </Button>
    //   ),
    // },
  ];

  //   const donwloadReportWithStatus = async (id: string) => {
  //     setSnackbarOpen(true);
  //     const res = await task(id);
  //     let data = res.data.features[0];
  //     if (data.status === "SUCCESS") {
  //       download(id);
  //       setSnackbarOpen(false);
  //     } else if (data.status === "INPROGRESS") {
  //       setTimeout(() => donwloadReportWithStatus(id), 2000);
  //     } else {
  //       setSnackbarOpen(false);
  //       openPopUp("Something went wrong", "Error");
  //     }
  //   };

  //   const download = async (id: string) => {
  //     await getReport(id);
  //   };

  //   const callMethod = async (requestBody: any) => {
  //     if (Object.keys(requestBody).length > 0) {
  //       const response = await downloadReport(requestBody);
  //       donwloadReportWithStatus(response.data.id);
  //     }
  //   };

  //   async function exportRateMasterReportToExcel(
  //     fromDate: string,
  //     designation: string,
  //     status: string,
  //     region: string
  //   ) {
  //     // Prepare the request body
  //     const requestBody = {
  //       attributes: {
  //         name: "RateTemplateDownload",
  //         format: "xlsx",
  //         fromDate: fromDate,
  //         filter: {
  //           filters: [
  //             { key: "designation", value: designation },
  //             { key: "status", value: status },
  //             { key: "region", value: region },
  //           ],
  //           operator: "and",
  //         },
  //       },
  //       lob: getLob(),
  //     };
  //     await callMethod(requestBody);
  //   }

  //   const handleSnackbarClose = (
  //     event?: React.SyntheticEvent | Event,
  //     reason?: string
  //   ) => {
  //     if (reason === "clickaway") {
  //       return;
  //     }

  //     setSnackbarOpen(false);
  //   };

  return (
    <div className="manage-rate-master-parent">
      <DefaultHeading
        heading={translate(
          TranslationEnum.manage_rate_master,
          "Manage Rate Master"
        )}
        showDefaultBackButton={true}
      />
      {showLoader ? (
        <div className="loader-center">
          <Loader />
        </div>
      ) : (
        <div className="manage-rate-master-container">
          <div className="rate-master-table">
            <DataGrid
              rows={rateMasterData}
              getRowId={(row) => row.id}
              columns={columns}
              sx={{
                width: "fit-content",
                minWidth: "100%",
              }}
            />
          </div>
        </div>
      )}

      {/* <ConfirmationPopUp
        message={translate(
          TranslationEnum.common_portal,
          "Are you sure want to export to excel?"
        )}
        openConfirmModal={confirmPopupState}
        successMethod={() => {
          if (selectedRowData) {
            exportRateMasterReportToExcel(
              selectedRowData.from_date,
              selectedRowData.designation,
              selectedRowData.status,
              selectedRowData.region
            );
          }
        }}
        setOpenConfirmModal={setConfirmPopupState}
      /> */}

      <GenericPopUp
        type={genericModaltype}
        message={genericModalMessage}
        openGenericModal={genericModalState}
        setOpenGenericModal={() => {
          setGenericModalState(false);
        }}
      />
      {/* <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {translate(
            TranslationEnum.common_portal,
            "Your report will be downloaded shortly"
          )}
        </Alert>
      </Snackbar> */}
    </div>
  );
}

export default ManageRateMaster;
